import { useContext } from 'react';
import { BackdropContext } from '../contexts/BackdropContext';

export default function useBackdrop() {
  const backdropContext = useContext(BackdropContext);

  if (!backdropContext) {
    throw Error('useBackdrop must be used within a BackdropContextProvider.');
  }

  return backdropContext;
}
